import { Trans, useTranslation } from 'react-i18next';

import teamIllustration from '@/assets/images/auth-team.webp';
import { Icon } from '@/shared/ui/atoms/Icon';
import './LoginAside.styl';

const FEATURES = ['a', 'b', 'c', 'd', 'e'] as const;

/**
 * Welcome panel of the auth screens: greeting, slogan and what Syncra covers over a teal field
 * that blends into the team illustration anchored at the bottom. Rendered with `asideBleed`.
 */
export function LoginAside() {
  const { t } = useTranslation(undefined, { keyPrefix: 'auth.aside' });
  return (
    <div className="f-aside">
      <div className="f-aside__content">
        <h1 className="f-aside__hello">{t('hello')}</h1>
        <p className="f-aside__slogan">
          <Trans i18nKey="auth.aside.slogan" components={{ b: <strong /> }} />
        </p>
        <ul className="f-aside__list">
          {FEATURES.map((key) => (
            <li key={key} className="f-aside__item">
              <span className="f-aside__check" aria-hidden="true">
                <Icon name="check" size={13} strokeWidth={2.8} />
              </span>
              {t(`features.${key}`)}
            </li>
          ))}
        </ul>
      </div>
      <img className="f-aside__art" src={teamIllustration} alt="" decoding="async" />
    </div>
  );
}
